<script setup lang="ts">
withDefaults(defineProps<{letter: string; vertical?: boolean}>(), {
    vertical: false,
});
</script>
<template>
    <div class="relative flex" :class="{'flex-col': vertical}">
        <div :class="[vertical ? 'sticky top-0.5 z-10' : 'w-10']">
            <h2
                class="dark:text--white flex items-center rounded-md font-bold text-askr-green"
                :class="[vertical ? 'bg-stone-50 py-2 pl-3 dark:bg-stone-800' : 'sticky top-0 py-5 pl-4']"
            >
                {{ letter }}
            </h2>
        </div>
        <div class="grow">
            <slot />
        </div>
    </div>
</template>
<style scoped></style>
